import { render, staticRenderFns } from "./users-modal-edit-profile.vue?vue&type=template&id=c54f0d7a"
import script from "./users-modal-edit-profile.vue?vue&type=script&lang=js"
export * from "./users-modal-edit-profile.vue?vue&type=script&lang=js"
import style0 from "./users-modal-edit-profile.vue?vue&type=style&index=0&id=c54f0d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports